import { render, staticRenderFns } from "./MerchantPriceDrawer.vue?vue&type=template&id=a38ce522&scoped=true"
import script from "./MerchantPriceDrawer.vue?vue&type=script&lang=js"
export * from "./MerchantPriceDrawer.vue?vue&type=script&lang=js"
import style0 from "./MerchantPriceDrawer.vue?vue&type=style&index=0&id=a38ce522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ce522",
  null
  
)

export default component.exports